import styled from "styled-components"
import {WorkSansMedium} from "@irati/ui/src/global/fonts"

const BigDesc = styled.div`
  ${WorkSansMedium};
  font-size: 18px;
  line-height: 21px;
  font-weight: normal;
  margin: 0;
  word-wrap: break-word;
`

export default BigDesc
